import { compose } from 'redux';
import actionTypes from './actionTypes';
import { serializeService } from '../serializers';

const initialState = {
    listing:{
        isLoading: false,
        areServicesLoaded: false,
        servicesList: [],
        error: undefined,
    }
};

export default (state = initialState, action) => {
    switch(action.type){
    case actionTypes.LOAD_SERVICES_START:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: true
            },
        };
    case actionTypes.LOAD_SERVICES_SUCCESS:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: false, 
                areServicesLoaded: true,
                servicesList: action.payload.data.map(serializeService),
            },
        };
    case actionTypes.LOAD_SERVICES_FAIL:
        return {
            ...state,
            listing: {
                ...state.listing,
                isLoading: false,
                error: action.payload.error
            },
        };
    default: 
        return state;
    }
};